import { Component } from 'react';
import { connect } from 'react-redux';

// import { PolicyConsentDTO } from '../../../../common/types/dto/PolicyConsentDTO';
import { CustomerDataDTO } from '../../../../common/types/dto/CustomerDataDTO';
import { ConfigProp, IsReadyToRenderProp, RenderPropWithProps } from '../../../../common/types/prop-types/common';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';

import { bindActionCreators } from 'redux';
import * as Actions from '../../../../common/services/customer/Actions';
import * as CustomerService from '../../../../common/services/customer/Service';
import { AppThunkDispatch } from '../../../common/types';

export interface HomeLayoutProps extends IsReadyToRenderProp, ConfigProp {
    policyConsentsAnswered: boolean; // PolicyConsentDTO | null;
}

export interface ReduxStateProps {
    customerInfo: CustomerDataDTO | undefined;
}

interface ReduxDispatchProps {
    customerActions: typeof Actions;
    customerServiceActions: CustomerService.ServiceActions;
}

class HomeLayoutContainer extends Component<ReduxStateProps & RenderPropWithProps<HomeLayoutProps> & ReduxDispatchProps> {
    public isReadyToRender(): boolean {
        return this.props.customerInfo ? true : false;
    }

    public async componentDidMount() {
        if (!this.props.customerInfo) {
            await this.props.customerServiceActions.customerData();
        }
    }

    public render() {
        const newProps: HomeLayoutProps = {
            policyConsentsAnswered: this.props.customerInfo ? this.props.customerInfo.policiesAccepted : false,
            isReadyToRender: this.isReadyToRender(),
            config,
        };
        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: RootState) => ({
    customerInfo: store.customerState.customerData.data.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    customerActions: bindActionCreators(Actions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeLayoutContainer);
